<template>
  <div>
    <advertisement-top-banner />
    <template>
      <Featured
        v-if="showBusinesKeyPoints"
        :features="[
          {
            image: 'img/delivery-truck.svg',
            title: 'features.freeShipping.title',
            description: 'features.freeShipping.description',
          },
          {
            image: '/img/headphones.svg',
            title: 'features.customerSupport.title',
            description: 'features.customerSupport.description',
          },
          {
            image: '/img/shopping-bag.svg',
            title: 'features.securePayment.title',
            description: 'features.securePayment.description',
          },
          {
            image: '/img/package.svg',
            title: 'features.moneyBack.title',
            description: 'features.moneyBack.description',
          },
        ]"
      />
    </template>
    <div v-if="$store.state.core.websiteMode === 'store'">
      <store />
    </div>
    <div v-else>
      <product />
    </div>
  </div>
</template>

<script>
import Featured from "../components/featured.vue";
import product from "./homePages/product.vue";
import store from "./homePages/store.vue";
import { mapState } from "vuex";

export default {
  components: {
    product,
    store,
    Featured,
  },
  data() {
    return {
      theme: {},
      marketName: "",
    };
  },
  computed: {
    ...mapState({
      tenantConfig: (state) => state.home.tenantConfig,
    }),
    showBusinesKeyPoints() {
      return this.tenantConfig?.buildConfig?.web?.dynamicFields
        ?.businessKeyPoints
        ? this.tenantConfig?.buildConfig?.web?.dynamicFields?.businessKeyPoints
        : false;
    },
  },
  mounted() {
    this.$store.commit("theme/updateTheme", {});
    this.$store.commit("theme/updateName", "");
  },
};
</script>
<style scoped>
.bottom-banner {
  display: block;
  margin: 50px auto 0;
  width: 100%;
  max-width: 1240px;
  height: auto;
}

@media (max-width: 768px) {
  .bottom-banner {
    margin-top: 20px;
    width: 90%;
    height: auto;
  }
}
</style>
